module.exports = __webpack_public_path__ + "img/6.fa3bf856.jpg";